import chroma from "chroma-js";

import {
  generateShade,
  generateTint,
  isContrastColor,
  getRGB
} from "./color.generator.js";
import {
  KEY_PRIMARY_500,
  DEFAULT_COLOR_CODE
} from "@base/common/constants/index.js";

function generateBgColor(hex, changeBg) {
  const [rgbArr, alpha] = getRGB(hex);
  let colors = {
    "Color.Bg.White": generateTint(rgbArr, 94),
    "Color.Bg.Gray": generateTint(rgbArr, 89)
  };

  if (changeBg) {
    for (let color in colors) {
      colors[color] = chroma([...colors[color], alpha]).hex();
    }
  } else {
    colors["Color.Bg.White"] = "#ffffff";
    colors["Color.Bg.Gray"] = "#f5f7fa";
  }
  return colors;
}

function generateGrayPallet(hex) {
  let [rgbArr, alpha] = getRGB(hex);
  let tintGrayList = generateTint(rgbArr, 80);
  let colors = {
    "Color.Gray.100": generateTint(rgbArr, 89),
    "Color.Gray.200": generateTint(rgbArr, 76),
    "Color.Gray.300": generateTint(rgbArr, 68),
    "Color.Gray.400": generateShade(tintGrayList, 15),
    "Color.Gray.500": generateShade(tintGrayList, 25),
    "Color.Gray.600": generateShade(tintGrayList, 35),
    "Color.Gray.700": generateShade(tintGrayList, 45),
    "Color.Gray.800": generateShade(tintGrayList, 55),
    "Color.Gray.900": generateShade(tintGrayList, 65),
    "Color.Gray.999": generateShade(tintGrayList, 85)
  };

  for (let color in colors) {
    colors[color] = chroma([...colors[color], alpha]).hex();
  }

  return colors;
}

function defaultNeutralValues() {
  let colors = {
    "Color.Gray.100": "#f7f7f8",
    "Color.Gray.200": "#e7e8eb",
    "Color.Gray.300": "#cfd2d7",
    "Color.Gray.400": "#afb4bc",
    "Color.Gray.500": "#979da8",
    "Color.Gray.600": "#7f8693",
    "Color.Gray.700": "#5c636e",
    "Color.Gray.800": "#3f444c",
    "Color.Gray.900": "#2e3137",
    "Color.Gray.999": "#17191c"
  };

  return colors;
}

export function generateColors(hex, changeBg) {
  let [rgbArr] = getRGB(hex);
  let colorPallet = {
    primaryColor: { [KEY_PRIMARY_500]: hex },
    grayPallet: changeBg ? generateGrayPallet(hex) : defaultNeutralValues(),
    bgColor: generateBgColor(hex, changeBg)
  };

  return {
    colorPallet,
    isContrast: isContrastColor(rgbArr)
  };
}

export const getColorVariables = (
  color = DEFAULT_COLOR_CODE,
  changeBg = false
) => {
  let { colorPallet, isContrast } = generateColors(color, changeBg);
  let { grayPallet, bgColor, primaryColor } = colorPallet;

  return {
    grayPallet,
    bgColor,
    isContrast,
    primaryColor
  };
};
